<template>
  <div>
    <label v-if="checkPayableTo" style="font-size: 1.1em">
      Make check payable to <b>{{ checkPayableTo }}</b>
    </label>
    <SelectBox
      v-model="receiverId"
      name="Collected by"
      label="Collected by"
      :options="receiverOptions"
      placeholder="Who collected the payment?"
      :validation-errors="v$.$errors"
      class="mb-2"
    />
    <TextField
      v-model="form.check_number"
      name="check_number"
      label="Check Number"
      class="mb-2 full-width"
      placeholder="Check Number"
      :validation-errors="v$.$errors"
    />
    <div class="d-flex gap-3">
      <TextField
        v-model="form.check_dl_number"
        name="check_dl_number"
        label="Drivers License #"
        class="mb-3 mr-2 full-width"
        placeholder="Drivers License #"
        :validation-errors="v$.$errors"
      />
      <TextField
        v-model="form.check_dl_state"
        name="check_dl_state"
        label="Drivers License State"
        class="mb-3 full-width"
        placeholder="Drivers License State"
        :validation-errors="v$.$errors"
      />
    </div>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import SelectBox from "../components/SelectBox.vue";
import TextField from "../components/TextField.vue";
import usePaymentMethods from "./usePaymentMethods";

export default {
  components: {
    SelectBox,
    TextField
  },
  props: {
    modelValue: { type: [Number, String], default: null },
    form: { type: Object, default: null }
  },
  emits: ["update:modelValue"],
  setup() {
    const { paymentMethodsResponse, receivers } = usePaymentMethods();
    return {
      paymentMethodsResponse,
      receivers,
      v$: useVuelidate()
    };
  },
  validations() {
    return {
      form: {
        check_number: { required, $autoDirty: true },
        check_dl_number: { required, $autoDirty: true },
        check_dl_state: { required, $autoDirty: true }
      },
      receiverId: { required, $autoDirty: true }
    };
  },
  computed: {
    receiverOptions() {
      return this.receivers.map((receiver) => ({
        value: `${receiver.id}_${receiver.type}`,
        label: receiver.full_name
      }));
    },
    checkPayableTo() {
      const check = this.paymentMethodsResponse.find(
        (method) => method.key === "check"
      );
      return check?.check_payable_to;
    },
    receiverId: {
      get() {
        return this.modelValue;
      },
      set(val) {
        return this.$emit("update:modelValue", val);
      }
    }
  }
};
</script>
